import React, { useState, memo } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { ArrowRight, CheckCircle, Copy, Check, MessageSquare, Smartphone, FileText, Search, Clock, AlertCircle, UserPlus, History, Zap, Brain, Star, Share2 as ShareIcon, Quote, Sparkles, TrendingUp, Heart, Eye } from 'lucide-react';
import { Link } from 'react-router-dom';
export function LandingPage() {
  const [copied, setCopied] = useState(false);
  const phoneNumber = '(774) 472-7423';
  const smsHref = `sms:+1${phoneNumber.replace(/\D/g, '')}?body=Hi%20ScribeTok!%20I%20want%20to%20transcribe%20a%20video.`;
  const handleCopyNumber = () => {
    navigator.clipboard.writeText(phoneNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="min-h-screen w-full bg-background px-4 py-12 md:px-16 lg:px-32 flex flex-col items-center justify-center overflow-x-hidden" data-id="element-447">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6" data-id="element-448">
        {/* Logo */}
        <div className="flex justify-center mb-10" data-id="element-449">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6tsscMEhsZ3L4JwT2r374e/ScribeTok-logo.png" alt="ScribeTok Logo" className="h-16 w-auto" data-id="element-450" />
        </div>

        {/* Hero Section - Updated to emphasize AI Chat */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-7 mb-16" data-id="element-451">
          <div className="md:col-span-12 flex flex-col justify-center bg-gradient-to-br from-background to-secondary/10 p-8 md:p-10 rounded-3xl border border-border/20 shadow-sm hover:shadow-md transition-all duration-300 animate-slide-down group" style={{
          animationDelay: '100ms'
        }} data-id="element-452">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-center md:text-center leading-tight tracking-tight max-w-4xl mx-auto" data-id="element-453">
              Chat with Your{' '}
              <span className="text-primary bg-primary/5 px-2 rounded-lg" data-id="element-454">
                TikTok Transcripts
              </span>
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground mb-4 text-center md:text-center max-w-2xl mx-auto" data-id="element-455">
              Get the transcript, best quote, and key takeaways. Then chat with
              AI to help you respond, share, or create.
            </p>
            {/* Platform Tags */}
            <div className="flex flex-wrap gap-3 mb-6 justify-center" data-id="element-456">
              <span className="bg-primary/10 text-primary px-4 py-1.5 rounded-full text-sm font-medium transition-transform hover:scale-105" data-id="element-457">
                TikTok
              </span>
              <span className="bg-primary/10 text-primary px-4 py-1.5 rounded-full text-sm font-medium transition-transform hover:scale-105" data-id="element-458">
                YouTube
              </span>
              <span className="bg-primary/10 text-primary px-4 py-1.5 rounded-full text-sm font-medium transition-transform hover:scale-105" data-id="element-459">
                Instagram
              </span>
              <span className="bg-primary/10 text-primary px-4 py-1.5 rounded-full text-sm font-medium transition-transform hover:scale-105" data-id="element-460">
                Facebook
              </span>
              <span className="bg-secondary/70 text-secondary-foreground px-4 py-1.5 rounded-full text-sm transition-transform hover:scale-105" data-id="element-461">
                SMS Powered
              </span>
            </div>
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mt-auto animate-fade-in justify-center max-w-2xl mx-auto w-full" style={{
            animationDelay: '300ms'
          }} data-id="element-462">
              <a href={smsHref} className="sm:min-w-[200px]" data-id="element-463">
                <Button size="lg" className="w-full text-base group whitespace-nowrap px-7 bg-primary hover:bg-primary/90" data-id="element-464">
                  <MessageSquare size={18} className="mr-3 group-hover:animate-bounce flex-shrink-0" data-id="element-465" />
                  Text to Try Now
                </Button>
              </a>
              <Link to="/app" className="sm:min-w-[200px]" data-id="element-466">
                <Button variant="outline" size="lg" className="w-full text-base group whitespace-nowrap px-7" data-id="element-467">
                  Browse Live Transcripts
                  <ArrowRight size={18} className="ml-3 group-hover:translate-x-1 transition-transform flex-shrink-0" data-id="element-468" />
                </Button>
              </Link>
              <Link to="/features" className="sm:min-w-[200px]" data-id="element-469">
                <Button variant="secondary" size="lg" className="w-full text-base whitespace-nowrap px-7" data-id="element-470">
                  <Star size={18} className="mr-3 flex-shrink-0" data-id="element-471" />
                  Creator Features
                </Button>
              </Link>
            </div>
          </div>

          {/* Right side column - now spans full width with 2 columns */}
          <div className="md:col-span-12 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-7" data-id="element-472">
            {/* SMS Card */}
            <Card className="overflow-hidden animate-scale border-border/20 shadow-sm hover:shadow-md transition-all duration-300 hover:border-border/40" style={{
            animationDelay: '200ms'
          }} data-id="element-473">
              <CardContent className="p-6 md:p-8 flex flex-col items-center" data-id="element-474">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-5 transition-transform hover:scale-110 duration-300" data-id="element-475">
                  <Smartphone size={28} className="text-primary" data-id="element-476" />
                </div>
                <h2 className="text-2xl font-medium mb-4" data-id="element-477">Text Us</h2>
                <div className="flex items-center gap-2 px-5 py-3 bg-secondary/70 rounded-full cursor-pointer mb-5 w-full justify-center hover:bg-secondary/90 transition-colors" onClick={handleCopyNumber} data-id="element-478">
                  <span className="font-medium" data-id="element-479">{phoneNumber}</span>
                  {copied ? <Check size={18} className="text-green-500" data-id="element-480" /> : <Copy size={18} data-id="element-481" />}
                </div>
                <img src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=sms:+17744727423" alt="SMS QR Code" className="mb-4 rounded-lg shadow-md transition-transform hover:scale-105 duration-300" width={150} height={150} data-id="element-482" />
                <p className="text-sm text-muted-foreground text-center" data-id="element-483">
                  Scan to open SMS on your phone
                </p>
              </CardContent>
            </Card>

            {/* App Preview/Conversation - Updated with AI Chat */}
            <div className="bg-secondary/20 rounded-3xl p-6 animate-fade-in overflow-hidden flex flex-col border border-border/20 shadow-sm hover:shadow-md transition-all duration-300 hover:border-border/40" style={{
            animationDelay: '300ms'
          }} data-id="element-484">
              <h3 className="text-lg font-medium mb-4" data-id="element-485">See It In Action</h3>
              <div className="space-y-3 overflow-y-auto flex-1 pr-1" data-id="element-486">
                <div className="flex justify-end" data-id="element-487">
                  <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-[230px] text-sm shadow-sm break-words" data-id="element-488">
                    https://tiktok.com/@user/video/123
                  </div>
                </div>
                <div className="flex justify-start" data-id="element-489">
                  <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-[230px] text-sm shadow-sm break-words" data-id="element-490">
                    <p className="flex items-start gap-2" data-id="element-491">
                      <span className="text-lg flex-shrink-0" data-id="element-492">✅</span>
                      <span data-id="element-493">Transcript ready!</span>
                    </p>
                    <p className="mt-2 ml-6 text-sm" data-id="element-494">
                      "Today I'm showing three productivity hacks..."
                    </p>
                  </div>
                </div>
                <div className="flex justify-end" data-id="element-495">
                  <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-[230px] text-sm shadow-sm break-words" data-id="element-496">
                    Help me respond to this - my wife sent it to me
                  </div>
                </div>
                <div className="flex justify-start" data-id="element-497">
                  <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-[230px] text-sm shadow-sm break-words" data-id="element-498">
                    <p className="flex items-start gap-2" data-id="element-499">
                      <span className="text-lg flex-shrink-0" data-id="element-500">💬</span>
                      <span data-id="element-501">
                        Here's a thoughtful response: "I watched this and it
                        really made me think about..."
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <Link to="/app" className="mt-4" data-id="element-502">
                <Button variant="outline" size="lg" className="w-full group" data-id="element-503">
                  Browse All Transcripts
                  <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-504" />
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {/* NEW: More Than Just Transcripts Section */}
        <div className="mb-16 animate-fade-in" style={{
        animationDelay: '350ms'
      }} data-id="element-505">
          <div className="text-center mb-8" data-id="element-506">
            <h2 className="text-3xl md:text-4xl font-bold mb-3" data-id="element-507">
              More Than Just Transcripts
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto" data-id="element-508">
              Get instant insights, AI-powered chat, and shareable quotes from
              every video
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-7" data-id="element-509">
            {/* Card 1 - AI Chat (highlighted) */}
            <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-3xl p-8 border-2 border-primary/30 shadow-md hover:shadow-lg transition-all duration-300 hover:border-primary/50 group" data-id="element-510">
              <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mb-5 transition-transform group-hover:scale-110 duration-300" data-id="element-511">
                <MessageSquare size={28} className="text-primary" data-id="element-512" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-513">
                Chat with Your Transcript
              </h3>
              <p className="text-muted-foreground mb-4" data-id="element-514">
                "Help me draft a response to this relationship advice." Our AI
                understands the full context and helps you engage.
              </p>
              <div className="bg-background/50 border border-border/40 rounded-xl p-4 mt-4" data-id="element-515">
                <p className="text-sm italic text-muted-foreground" data-id="element-516">
                  "My wife sent me this TikTok about communication... help me
                  write a thoughtful response."
                </p>
              </div>
            </div>

            {/* Card 2 - Quote Extraction */}
            <div className="bg-secondary/10 rounded-3xl p-8 border border-border/20 shadow-sm hover:shadow-md transition-all duration-300 hover:border-border/40 group" data-id="element-517">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-5 transition-transform group-hover:scale-110 duration-300" data-id="element-518">
                <Quote size={28} className="text-primary" data-id="element-519" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-520">
                Best Quote Extraction
              </h3>
              <p className="text-muted-foreground mb-4" data-id="element-521">
                AI picks the most memorable, shareable moment from every video.
              </p>
              <div className="bg-secondary/30 rounded-xl p-3 mt-4 font-mono text-sm" data-id="element-522">
                <span className="text-primary" data-id="element-523">/quote</span> - Get just the best
                quote
              </div>
            </div>

            {/* Card 3 - TLDR */}
            <div className="bg-secondary/10 rounded-3xl p-8 border border-border/20 shadow-sm hover:shadow-md transition-all duration-300 hover:border-border/40 group" data-id="element-524">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-5 transition-transform group-hover:scale-110 duration-300" data-id="element-525">
                <Sparkles size={28} className="text-primary" data-id="element-526" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-527">Instant TLDR</h3>
              <p className="text-muted-foreground mb-4" data-id="element-528">
                3-5 bullet points capturing the key takeaways. Skip the fluff.
              </p>
              <div className="bg-secondary/30 rounded-xl p-3 mt-4 font-mono text-sm" data-id="element-529">
                <span className="text-primary" data-id="element-530">/tldr</span> - Key points only
              </div>
            </div>
          </div>
        </div>

        {/* NEW: Discover What's Trending Section */}
        <div className="mb-16 animate-fade-in" style={{
        animationDelay: '400ms'
      }} data-id="element-531">
          <div className="bg-secondary/10 rounded-3xl p-8 border border-border/20 shadow-sm hover:shadow-md transition-all duration-300 hover:border-border/40" data-id="element-532">
            <div className="flex items-center justify-between mb-6" data-id="element-533">
              <div data-id="element-534">
                <h2 className="text-3xl font-bold mb-2 flex items-center gap-3" data-id="element-535">
                  <TrendingUp size={32} className="text-primary" data-id="element-536" />
                  Discover What's Trending
                </h2>
                <p className="text-muted-foreground" data-id="element-537">
                  Browse transcripts from viral videos. Find insights others are
                  sharing.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-538">
              {/* Trending Card 1 */}
              <div className="bg-background/50 rounded-2xl p-6 hover:bg-background/80 transition-all duration-300 hover:scale-105 border border-border/20" data-id="element-539">
                <div className="flex items-start justify-between mb-3" data-id="element-540">
                  <h3 className="font-semibold text-lg leading-tight" data-id="element-541">
                    Why Gen Z is Quiet Quitting
                  </h3>
                  <span className="bg-primary/10 text-primary text-xs px-2 py-1 rounded-full whitespace-nowrap" data-id="element-542">
                    Career
                  </span>
                </div>
                <div className="flex items-center gap-4 text-sm text-muted-foreground" data-id="element-543">
                  <span className="flex items-center gap-1" data-id="element-544">
                    <Heart size={14} className="text-primary" data-id="element-545" />
                    2.3M
                  </span>
                  <span className="flex items-center gap-1" data-id="element-546">
                    <Eye size={14} data-id="element-547" />
                    8.1M
                  </span>
                </div>
              </div>

              {/* Trending Card 2 */}
              <div className="bg-background/50 rounded-2xl p-6 hover:bg-background/80 transition-all duration-300 hover:scale-105 border border-border/20" data-id="element-548">
                <div className="flex items-start justify-between mb-3" data-id="element-549">
                  <h3 className="font-semibold text-lg leading-tight" data-id="element-550">
                    The Psychology of First Impressions
                  </h3>
                  <span className="bg-primary/10 text-primary text-xs px-2 py-1 rounded-full whitespace-nowrap" data-id="element-551">
                    Psychology
                  </span>
                </div>
                <div className="flex items-center gap-4 text-sm text-muted-foreground" data-id="element-552">
                  <span className="flex items-center gap-1" data-id="element-553">
                    <Heart size={14} className="text-primary" data-id="element-554" />
                    1.8M
                  </span>
                  <span className="flex items-center gap-1" data-id="element-555">
                    <Eye size={14} data-id="element-556" />
                    6.2M
                  </span>
                </div>
              </div>

              {/* Trending Card 3 */}
              <div className="bg-background/50 rounded-2xl p-6 hover:bg-background/80 transition-all duration-300 hover:scale-105 border border-border/20" data-id="element-557">
                <div className="flex items-start justify-between mb-3" data-id="element-558">
                  <h3 className="font-semibold text-lg leading-tight" data-id="element-559">
                    How to Actually Save Money in 2024
                  </h3>
                  <span className="bg-primary/10 text-primary text-xs px-2 py-1 rounded-full whitespace-nowrap" data-id="element-560">
                    Finance
                  </span>
                </div>
                <div className="flex items-center gap-4 text-sm text-muted-foreground" data-id="element-561">
                  <span className="flex items-center gap-1" data-id="element-562">
                    <Heart size={14} className="text-primary" data-id="element-563" />
                    3.1M
                  </span>
                  <span className="flex items-center gap-1" data-id="element-564">
                    <Eye size={14} data-id="element-565" />
                    12.4M
                  </span>
                </div>
              </div>
            </div>

            <div className="flex justify-center mt-6" data-id="element-566">
              <Link to="/app" data-id="element-567">
                <Button size="lg" variant="outline" className="group" data-id="element-568">
                  Browse All Transcripts
                  <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-569" />
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {/* Features Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-7 mb-16" data-id="element-570">
          {/* How It Works - Spans 8 columns on larger screens */}
          <div className="md:col-span-8 bg-secondary/10 rounded-3xl p-8 animate-fade-in border border-border/20 shadow-sm hover:shadow-md transition-all duration-300 hover:border-border/40 group" style={{
          animationDelay: '500ms'
        }} data-id="element-571">
            <h3 className="text-2xl font-medium mb-6 group-hover:text-primary transition-colors" data-id="element-572">
              How It Works
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-573">
              <div className="flex flex-col items-center text-center p-4 bg-background/50 rounded-2xl hover:bg-background/80 transition-colors" data-id="element-574">
                <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mb-4 transition-transform hover:scale-110 duration-300" data-id="element-575">
                  <MessageSquare size={24} className="text-primary" data-id="element-576" />
                </div>
                <h3 className="text-lg font-medium mb-2" data-id="element-577">
                  Step 1: Text a video link
                </h3>
                <p className="text-sm text-muted-foreground" data-id="element-578">
                  Send any TikTok URL to {phoneNumber}
                </p>
              </div>
              <div className="flex flex-col items-center text-center p-4 bg-background/50 rounded-2xl hover:bg-background/80 transition-colors" data-id="element-579">
                <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mb-4 transition-transform hover:scale-110 duration-300" data-id="element-580">
                  <FileText size={24} className="text-primary" data-id="element-581" />
                </div>
                <h3 className="text-lg font-medium mb-2" data-id="element-582">
                  Step 2: Wait a moment
                </h3>
                <p className="text-sm text-muted-foreground" data-id="element-583">
                  Our AI extracts the text quickly
                </p>
              </div>
              <div className="flex flex-col items-center text-center p-4 bg-background/50 rounded-2xl hover:bg-background/80 transition-colors" data-id="element-584">
                <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mb-4 transition-transform hover:scale-110 duration-300" data-id="element-585">
                  <ShareIcon size={24} className="text-primary" data-id="element-586" />
                </div>
                <h3 className="text-lg font-medium mb-2" data-id="element-587">
                  Step 3: Get your transcript
                </h3>
                <p className="text-sm text-muted-foreground" data-id="element-588">
                  Receive text with a shareable link
                </p>
              </div>
            </div>
          </div>

          {/* Key Benefits - Takes 4 columns */}
          <div className="md:col-span-4 bg-primary/5 rounded-3xl p-8 animate-fade-in border border-primary/10 shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/20 group" style={{
          animationDelay: '600ms'
        }} data-id="element-589">
            <h3 className="text-2xl font-medium mb-6 flex items-center group-hover:text-primary transition-colors" data-id="element-590">
              <Zap size={20} className="text-primary mr-3" data-id="element-591" />
              Key Benefits
            </h3>
            <div className="space-y-5" data-id="element-592">
              <div className="flex items-start gap-4 p-3 bg-background/50 rounded-2xl hover:bg-background/80 transition-colors" data-id="element-593">
                <History size={20} className="text-primary mt-1 flex-shrink-0" data-id="element-594" />
                <div data-id="element-595">
                  <p className="font-medium text-base" data-id="element-596">No Account Needed</p>
                  <p className="text-sm text-muted-foreground" data-id="element-597">
                    Transcripts saved to your phone number
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 p-3 bg-background/50 rounded-2xl hover:bg-background/80 transition-colors" data-id="element-598">
                <UserPlus size={20} className="text-primary mt-1 flex-shrink-0" data-id="element-599" />
                <div data-id="element-600">
                  <p className="font-medium text-base" data-id="element-601">Create Account Later</p>
                  <p className="text-sm text-muted-foreground" data-id="element-602">
                    Text <span className="font-medium" data-id="element-603">/register</span> anytime
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 p-3 bg-background/50 rounded-2xl hover:bg-background/80 transition-colors" data-id="element-604">
                <Brain size={20} className="text-primary mt-1 flex-shrink-0" data-id="element-605" />
                <div data-id="element-606">
                  <p className="font-medium text-base" data-id="element-607">Powerful Commands</p>
                  <p className="text-sm text-muted-foreground" data-id="element-608">
                    Use <span className="font-medium" data-id="element-609">/summary</span> for
                    insights
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Trust and Commands Bento Grid - Updated with new commands */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-7 mb-16" data-id="element-610">
          {/* Trust Indicators - Takes 4 columns */}
          <div className="md:col-span-4 flex flex-col justify-center bg-secondary/10 rounded-3xl p-8 animate-fade-in border border-border/20 shadow-sm hover:shadow-md transition-all duration-300 hover:border-border/40" style={{
          animationDelay: '700ms'
        }} data-id="element-611">
            <h3 className="text-2xl font-medium mb-6" data-id="element-612">Why Trust Us</h3>
            <div className="space-y-4" data-id="element-613">
              <div className="flex items-center gap-3 p-3 bg-background/50 rounded-2xl hover:bg-background/80 transition-colors" data-id="element-614">
                <CheckCircle size={22} className="text-success" data-id="element-615" />
                <span className="text-base font-medium" data-id="element-616">Fast & Accurate</span>
              </div>
              <div className="flex items-center gap-3 p-3 bg-background/50 rounded-2xl hover:bg-background/80 transition-colors" data-id="element-617">
                <CheckCircle size={22} className="text-success" data-id="element-618" />
                <span className="text-base font-medium" data-id="element-619">
                  Multiple Languages
                </span>
              </div>
              <div className="flex items-center gap-3 p-3 bg-background/50 rounded-2xl hover:bg-background/80 transition-colors" data-id="element-620">
                <CheckCircle size={22} className="text-success" data-id="element-621" />
                <span className="text-base font-medium" data-id="element-622">
                  Public Videos Only
                </span>
              </div>
            </div>
          </div>

          {/* SMS Commands - Takes 8 columns - Updated with new commands */}
          <div className="md:col-span-8 rounded-3xl overflow-hidden animate-fade-in" style={{
          animationDelay: '800ms'
        }} data-id="element-623">
            <div className="bg-secondary/10 p-8 rounded-3xl border border-border/20 shadow-sm hover:shadow-md transition-all duration-300 hover:border-border/40" data-id="element-624">
              <h3 className="text-2xl font-medium mb-6" data-id="element-625">SMS Commands</h3>
              <div className="grid grid-cols-2 gap-4" data-id="element-626">
                <div className="bg-secondary/30 p-4 rounded-xl hover:bg-secondary/50 transition-colors hover:scale-105 transform duration-300 border border-border/20" data-id="element-627">
                  <p className="font-medium text-base" data-id="element-628">/help</p>
                  <p className="text-sm text-muted-foreground" data-id="element-629">
                    List all commands
                  </p>
                </div>
                <div className="bg-secondary/30 p-4 rounded-xl hover:bg-secondary/50 transition-colors hover:scale-105 transform duration-300 border border-border/20" data-id="element-630">
                  <p className="font-medium text-base" data-id="element-631">/register</p>
                  <p className="text-sm text-muted-foreground" data-id="element-632">
                    Create account
                  </p>
                </div>
                <div className="bg-primary/10 p-4 rounded-xl hover:bg-primary/20 transition-colors hover:scale-105 transform duration-300 border border-primary/20" data-id="element-633">
                  <p className="font-medium text-base flex items-center gap-2" data-id="element-634">
                    <MessageSquare size={16} className="text-primary" data-id="element-635" />
                    /chat
                  </p>
                  <p className="text-sm text-muted-foreground" data-id="element-636">
                    Ask questions about transcript
                  </p>
                </div>
                <div className="bg-primary/10 p-4 rounded-xl hover:bg-primary/20 transition-colors hover:scale-105 transform duration-300 border border-primary/20" data-id="element-637">
                  <p className="font-medium text-base flex items-center gap-2" data-id="element-638">
                    <Quote size={16} className="text-primary" data-id="element-639" />
                    /quote
                  </p>
                  <p className="text-sm text-muted-foreground" data-id="element-640">
                    Get best quote
                  </p>
                </div>
                <div className="bg-primary/10 p-4 rounded-xl hover:bg-primary/20 transition-colors hover:scale-105 transform duration-300 border border-primary/20" data-id="element-641">
                  <p className="font-medium text-base flex items-center gap-2" data-id="element-642">
                    <Sparkles size={16} className="text-primary" data-id="element-643" />
                    /tldr
                  </p>
                  <p className="text-sm text-muted-foreground" data-id="element-644">Key takeaways</p>
                </div>
                <div className="bg-secondary/30 p-4 rounded-xl hover:bg-secondary/50 transition-colors hover:scale-105 transform duration-300 border border-border/20" data-id="element-645">
                  <p className="font-medium text-base" data-id="element-646">/summary</p>
                  <p className="text-sm text-muted-foreground" data-id="element-647">
                    Get quick insights
                  </p>
                </div>
                <div className="bg-secondary/30 p-4 rounded-xl hover:bg-secondary/50 transition-colors hover:scale-105 transform duration-300 border border-border/20" data-id="element-648">
                  <p className="font-medium text-base" data-id="element-649">/vault</p>
                  <p className="text-sm text-muted-foreground" data-id="element-650">
                    View recent transcripts
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Full Conversation Example - Updated with AI Chat */}
        <div className="mb-16 animate-fade-in" style={{
        animationDelay: '900ms'
      }} data-id="element-651">
          <div className="bg-secondary/10 rounded-3xl p-6 md:p-8 border border-border/20 shadow-sm hover:shadow-md transition-all duration-300 hover:border-border/40" data-id="element-652">
            <div className="flex items-center justify-between mb-5" data-id="element-653">
              <h3 className="text-2xl font-medium" data-id="element-654">
                Complete Conversation Flow
              </h3>
              <div className="bg-primary/10 text-primary px-3 py-1 rounded-full text-xs font-medium" data-id="element-655">
                Real-time Experience
              </div>
            </div>
            <div className="max-w-2xl mx-auto bg-background/50 p-5 rounded-2xl" data-id="element-656">
              <div className="space-y-4" data-id="element-657">
                {/* First message */}
                <div className="flex justify-end" data-id="element-658">
                  <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-[280px] shadow-sm break-words hover:scale-105 transition-transform" data-id="element-659">
                    https://www.tiktok.com/@username/video/1234567890
                  </div>
                </div>
                {/* Response messages */}
                <div className="flex justify-start" data-id="element-660">
                  <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-[280px] shadow-sm break-words hover:scale-105 transition-transform" data-id="element-661">
                    <p className="flex items-start gap-2" data-id="element-662">
                      <span className="text-xl flex-shrink-0" data-id="element-663">🎬</span>
                      <span data-id="element-664">
                        Thanks for using ScribeTok! You'll receive a transcript
                        shortly.
                      </span>
                    </p>
                  </div>
                </div>
                <div className="flex justify-start" data-id="element-665">
                  <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-[280px] shadow-sm break-words hover:scale-105 transition-transform" data-id="element-666">
                    <p className="flex items-start gap-2" data-id="element-667">
                      <span className="text-xl flex-shrink-0" data-id="element-668">⏳</span>
                      <span data-id="element-669">Got your link! Transcribing now...</span>
                    </p>
                  </div>
                </div>
                {/* Transcript result */}
                <div className="flex justify-start" data-id="element-670">
                  <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-[350px] shadow-sm break-words hover:scale-105 transition-transform" data-id="element-671">
                    <p className="flex items-start gap-2" data-id="element-672">
                      <span className="text-xl flex-shrink-0" data-id="element-673">✅</span>
                      <span data-id="element-674">Transcript ready!</span>
                    </p>
                    <p className="mt-3 ml-7" data-id="element-675">
                      "Hey everyone, today I'm going to show you three
                      productivity hacks that changed my life..."
                    </p>
                    <p className="text-xs mt-3 text-primary font-medium ml-7" data-id="element-676">
                      share.scribetok.com/v/b70c860b-d7dc
                    </p>
                  </div>
                </div>
                {/* AI Chat request */}
                <div className="flex justify-end" data-id="element-677">
                  <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-[280px] shadow-sm break-words hover:scale-105 transition-transform" data-id="element-678">
                    Help me respond to this - my wife sent it to me
                  </div>
                </div>
                {/* AI Chat response */}
                <div className="flex justify-start" data-id="element-679">
                  <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-[350px] shadow-sm break-words hover:scale-105 transition-transform" data-id="element-680">
                    <p className="flex items-start gap-2" data-id="element-681">
                      <span className="text-xl flex-shrink-0" data-id="element-682">💬</span>
                      <span className="font-medium" data-id="element-683">
                        Here's a thoughtful response:
                      </span>
                    </p>
                    <p className="mt-3 ml-7 text-sm" data-id="element-684">
                      "I watched this and it really made me think about how we
                      can improve our daily routines together. The time blocking
                      idea especially resonated with me..."
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex justify-center mt-6" data-id="element-685">
              <div className="flex items-center gap-3 text-sm text-muted-foreground bg-secondary/30 px-4 py-2 rounded-full" data-id="element-686">
                <span className="text-primary" data-id="element-687">🔄</span>
                <span data-id="element-688">Experience this yourself in seconds</span>
              </div>
            </div>
          </div>
        </div>

        {/* Compliance Footer */}
        <div className="mt-8 border-t border-border/30 pt-6 text-sm text-muted-foreground" data-id="element-689">
          <p data-id="element-690">
            ScribeTok is a user-initiated SMS service. We do not send
            promotional messages. You can opt out at any time by replying STOP.
            Msg & data rates may apply.
          </p>
          <p className="mt-3" data-id="element-691">
            <Link to="/text/compliance" className="text-primary hover:underline" data-id="element-692">
              View full terms
            </Link>
          </p>
        </div>
      </div>
    </div>;
}